<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'SupportEmail',
    data(){
      return {
        subject: '',
        body: '',
      }
    },
    methods: {
      ...mapActions("email", ["sendSupportEmail"]),
      trySendEmail(){
        const payload = {
          email: {
            to: this.selectedEmailAddress,
            subject: this.subject,
            body: this.body
          }
        }; 
        this.sendSupportEmail(payload)
          .then(()=> {
            this.subject = '';
            this.body = '';
          });
        
      }
    },
    computed: {
      ...mapState("email", ["selectedEmailAddress"])
    }
  }
</script>
<template>
  <div>
    <b-modal id="modal-Email" :title="this.selectedEmailAddress" 
      ok-only ok-variant="secondary" ok-title="Submit" @ok="trySendEmail">
      <div>
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
            class="mb-3"
            label="Subject"
            label-for="subject-input"
            label-cols-lg="4"
          >
            <b-form-input
              id="subject-input"
              type="text"
              v-model="subject"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="mb-3"
            label="Body"
            label-for="body-input"
            label-cols-lg="4"
          >
            <b-form-textarea
              id="body-input"
              v-model="body"
            >
            </b-form-textarea>
          </b-form-group>
        </form>
      </div>
    </b-modal>
  </div>
</template>
    